"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFutureShowings = exports.getFutureShowingsForApplication = void 0;
var dates_1 = require("../../dates");
/**
 * Get future showings for application if application (applicant)
 * does not yet exist in any of the showings
 */
var getFutureShowingsForApplication = function (showings, applicationId) {
    return showings.some(function (_a) {
        var applicationIds = _a.applicationIds;
        return (applicationIds ? applicationIds.includes(applicationId) : false);
    })
        ? undefined
        : showings.filter(function (_a) {
            var startDate = _a.startDate;
            return new Date(startDate) > new Date();
        });
};
exports.getFutureShowingsForApplication = getFutureShowingsForApplication;
/** if not reserved, showing needs to be 2 hours in the future so landlord has time to go to the apartment.
 *
 * If openHouse with reservations/applictionIdList, can be reserved immediately (as showing is already happening)
 *
 * If you want all future showings and don't care about the time limit for reserving, boolean is false
 */
var getFutureShowings = function (showings, timeLimitForReservation) {
    return showings.filter(function (_a) {
        var startDate = _a.startDate, showingIsReserved = _a.applicationIds, type = _a.type;
        var showingNeedsToBeHoursInFuture = 0;
        if (timeLimitForReservation) {
            if (type === 'personal') {
                /** check against reservations even if they are a bit in the past
                 * so users cannot reserve showings before status is followUp */
                showingNeedsToBeHoursInFuture = showingIsReserved ? -1 : 2;
            }
            else if (type === 'openHouse') {
                showingNeedsToBeHoursInFuture = showingIsReserved ? 0 : 2;
            }
        }
        var currentDatePlusHoursInFuture = dates_1.addHours(dates_1.getDateNow(), showingNeedsToBeHoursInFuture).valueOf();
        return dates_1.isInFuture(Date.parse(startDate), currentDatePlusHoursInFuture);
    });
};
exports.getFutureShowings = getFutureShowings;
//# sourceMappingURL=filtering.js.map